'use client';

import { useState, useEffect } from 'react';
import Header from '@/components/common/Header';
import HeroSection from './HeroSection';
import QRCodeSection from './QRCodeSection';
import FeaturesComparison from './FeaturesComparison';
import DeviceCompatibility from './DeviceCompatibility';
import AppPreview from './AppPreview';
import OnboardingPreview from './OnboardingPreview';
import SecuritySection from './SecuritySection';
import FAQSection from './FAQSection';
import CTASection from './CTASection';
import Footer from './Footer';

const AppDownloadInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleDownloadClick = (platform: 'ios' | 'android') => {
    if (!isHydrated) return;

    const urls = {
      ios: 'https://apps.apple.com/signaly',
      android: 'https://play.google.com/store/apps/signaly'
    };

    window.open(urls[platform], '_blank');
  };

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <HeroSection onDownloadClick={handleDownloadClick} />
        <QRCodeSection />
        <FeaturesComparison />
        <DeviceCompatibility />
        <AppPreview />
        <OnboardingPreview />
        <SecuritySection />
        <FAQSection />
        <CTASection onDownloadClick={handleDownloadClick} />
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <HeroSection onDownloadClick={handleDownloadClick} />
      <QRCodeSection />
      <FeaturesComparison />
      <DeviceCompatibility />
      <AppPreview />
      <OnboardingPreview />
      <SecuritySection />
      <FAQSection />
      <CTASection onDownloadClick={handleDownloadClick} />
      <Footer />
    </div>
  );
};

export default AppDownloadInteractive;